
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dokumenty",
      function () {
        return require("private-next-pages/dokumenty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dokumenty"])
      });
    }
  